<mat-dialog-content>
    <div class="pt-4 px-4 animated fadeIn" [ngSwitch]="data.id">
        <app-feature-payables *ngSwitchCase="1" (getStartedEnrollment)="redirect()"></app-feature-payables>
        <app-feature-alliance-banking *ngSwitchCase="0" (requestScheduleCall)="openTab()"></app-feature-alliance-banking>
    </div>
</mat-dialog-content>

<img class="mat-close" src="/assets/images/payhoa/other/icon_close.svg" mat-dialog-close>
